import { render, staticRenderFns } from "./ServiceDeliveryTask.vue?vue&type=template&id=4fc162b7&"
import script from "./ServiceDeliveryTask.vue?vue&type=script&lang=js&"
export * from "./ServiceDeliveryTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports